var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 133,
    viewBox: "0 0 131 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_44)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 40.5L40 55L41.5 77.5L60 88L76 92.5L90 71.5L90.5 55L81 46L67 40L53.5 40.5Z",
    fill: "#011F62"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 46L70.6456 53.8485L65.7701 66.153L68.6954 83.9759L63.0771 80.3218L59.9197 88.5L41.5 77.5L40 54.9423L53.2797 40.5L67 40L81 46Z",
    fill: "#610051"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92.5L68.9732 83.5665L67.4065 69.5L60 88.058L76 92.5Z",
    fill: "#0856A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54.5L45 75L61 84.2185L59.4161 88.5L41.5 77.5L40 54.5Z",
    fill: "#0856A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_44",
    x: 0,
    y: 0,
    width: 130.5,
    height: 132.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.0980392 0 0 0 0 0.929412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_44",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.98b3b4c649d3fe8ce96f5feaaa757240.svg";
export { ForwardRef as ReactComponent };